module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    class: ['small-box', _vm.selectedGroup.group && _vm.selectedGroup.group.color !== null ? _vm.selectedGroup.group.color : _vm.defaultGColor]
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('h3', [_c('div', {
    staticClass: "col-sm-10"
  }, [(_vm.selectedGroup.empty) ? _c('span', [_vm._v(_vm._s(_vm.$t('pages.adminpanel.group.createGroupPrompt')))]) : (_vm.selectedGroup.group) ? _c('span', [_vm._v(_vm._s(_vm.$t('pages.adminpanel.group.groupPrompt')) + ": " + _vm._s(_vm._f("pickTranslation")(_vm.selectedGroup.group.name)))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "btn-group col-sm-2"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [(!_vm.selectedGroup.empty) ? _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.colapseEditGroup(2)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-edit"
  })]) : _vm._e()])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('h3', [_c('div', {
    staticClass: "col-sm-10"
  }, [(!_vm.selectedYear.empty) ? _c('b', [_vm._v(_vm._s(_vm.$t('pages.adminpanel.year.yearPrompt')) + ": " + _vm._s(_vm.selectedYear.name))]) : _c('b', [_vm._v(_vm._s(_vm.$t('pages.adminpanel.year.createYear')))])]), _vm._v(" "), (!_vm.selectedGroup.empty) ? _c('div', {
    staticClass: "btn-group col-sm-2"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [(!_vm.selectedYear.empty) ? _c('button', {
    staticClass: "btn btn-default dropdown-toggle",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown",
      "aria-expanded": "true"
    }
  }, [_c('span', {
    staticClass: "fa fa-arrow-down"
  }), _vm._v(" "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle Dropdown")])]) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu",
    attrs: {
      "role": "menu"
    }
  }, _vm._l((_vm.groupYears), function(gj) {
    return _c('li', [_c('a', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.updateYear(gj)
        }
      }
    }, [_vm._v(_vm._s(gj.name))])])
  }), 0), _vm._v(" "), (!_vm.selectedYear.empty) ? _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.colapseEditYear(4)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-edit"
  })]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.colapseCreateYear(3)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])])]) : _vm._e()])])]), _vm._v(" "), (!_vm.colEG) ? _c('div', {
    staticClass: "small-box-footer"
  }, [_c('editgroup', {
    attrs: {
      "group": _vm.selectedGroup.group
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.colCY) ? _c('div', {
    staticClass: "small-box-footer",
    staticStyle: {
      "text-align": "unset"
    }
  }, [_c('createyear', {
    attrs: {
      "gid": _vm.gid
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.colEY) ? _c('div', {
    staticClass: "small-box-footer",
    staticStyle: {
      "text-align": "unset"
    }
  }, [_c('edityear', {
    attrs: {
      "year": _vm.selectedYear
    }
  })], 1) : _vm._e()])]), _vm._v(" "), (!_vm.selectedYear.empty && _vm.selectedGroup.group) ? _c('span', [_c('div', {
    staticClass: "col-xs-12",
    class: [_vm.ratingStatistics ? 'col-md-4' : 'col-md-6', _vm.ratingStatistics ? 'col-sm-4' : 'col-sm-6']
  }, [_c('router-link', {
    staticClass: "small-box-footer",
    attrs: {
      "to": {
        name: 'exercises',
        params: {
          gid: _vm.selectedGroup.group.id.toString(),
          yid: _vm.selectedYear.id.toString(),
          sid: 'root'
        }
      }
    }
  }, [_c('div', {
    class: ['small-box', _vm.selectedGroup.group && _vm.selectedGroup.group.color !== null ? _vm.selectedGroup.group.color : _vm.defaultGColor]
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('pages.adminpanel.exercises.bannerName')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('pages.adminpanel.exercises.manageExercisesButton')))])]), _vm._v(" "), _c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-inbox"
  })])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12",
    class: [_vm.ratingStatistics ? 'col-md-4' : 'col-md-6', _vm.ratingStatistics ? 'col-sm-4' : 'col-sm-6']
  }, [_c('router-link', {
    staticClass: "small-box-footer",
    attrs: {
      "to": {
        name: 'classes',
        params: {
          gid: _vm.selectedGroup.group.id.toString(),
          yid: _vm.selectedYear.id.toString()
        }
      }
    }
  }, [_c('div', {
    staticClass: "small-box bg-red"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('pages.adminpanel.classes.bannerName')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('pages.adminpanel.classes.manageClassesButton')))])]), _vm._v(" "), _c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-users"
  })])])])], 1), _vm._v(" "), (_vm.ratingStatistics) ? _c('div', {
    staticClass: "col-md-4 col-sm-4 col-xs-12 clickable"
  }, [_c('div', {
    staticClass: "small-box-footer",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#modal-userRatings"
    }
  }, [_c('div', {
    staticClass: "small-box bg-blue"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('pages.adminpanel.ratingStatistics.bannerName')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('pages.adminpanel.ratingStatistics.studentRatings')))])]), _vm._v(" "), _vm._m(0)])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-sm-6 col-xs-12"
  }, [_c('div', {
    staticClass: "info-box"
  }, [_c('span', {
    class: ['info-box-icon', _vm.selectedGroup.group && _vm.selectedGroup.group.color !== null ? _vm.selectedGroup.group.color : _vm.defaultGColor]
  }, [_c('i', {
    staticClass: "fa fa-inbox"
  })]), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-text"
  }, [_vm._v(_vm._s(_vm.$t('pages.adminpanel.subgroup.nmOfSubgroupsPrompt')))]), _vm._v(" "), _c('span', {
    staticClass: "info-box-number"
  }, [_vm._v(_vm._s(_vm.selectedGroup.subgroups.length))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-sm-6 col-xs-12"
  }, [_c('div', {
    staticClass: "info-box"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-text"
  }, [_vm._v(_vm._s(_vm.$t('pages.adminpanel.tablets.nmOfExamsPrompt')))]), _vm._v(" "), _c('span', {
    staticClass: "info-box-number"
  }, [_vm._v(_vm._s(_vm.selectedGroup.exams.length))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-sm-6 col-xs-12"
  }, [_c('div', {
    staticClass: "info-box"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-text"
  }, [_vm._v(_vm._s(_vm.$t('pages.adminpanel.users.nmOfUsersPrompt')))]), _vm._v(" "), _c('span', {
    staticClass: "info-box-number"
  }, [_vm._v(_vm._s(_vm.userCount))])])])]), _vm._v(" "), (_vm.ratingStatistics) ? _c('div', {
    staticClass: "col-md-4 col-sm-6 col-xs-12"
  }, [_c('div', {
    staticClass: "info-box"
  }, [_c('span', {
    class: ['info-box-icon', _vm.selectedGroup.group && _vm.selectedGroup.group.color !== null ? _vm.selectedGroup.group.color : _vm.defaultGColor]
  }, [_c('i', {
    staticClass: "fa fa-line-chart"
  })]), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-text",
    staticStyle: {
      "white-space": "pre-wrap"
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.adminpanel.ratingStatistics.ratingExamsInLastWeek')))]), _vm._v(" "), _c('span', {
    staticClass: "info-box-number"
  }, [_vm._v(_vm._s(_vm.ratingStatistics.ratingExamsLastWeek))])])])]) : _vm._e(), _vm._v(" "), (_vm.ratingStatistics) ? _c('div', {
    staticClass: "col-md-4 col-sm-6 col-xs-12"
  }, [_c('div', {
    staticClass: "info-box"
  }, [_c('span', {
    class: ['info-box-icon', _vm.selectedGroup.group && _vm.selectedGroup.group.color !== null ? _vm.selectedGroup.group.color : _vm.defaultGColor]
  }, [(_vm.ratingStatistics.averageChangeOfRatingInTheLastWeek >= 0) ? _c('i', {
    staticClass: "fa fa-chevron-up"
  }) : _c('i', {
    staticClass: "fa fa-chevron-down"
  })]), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-text",
    staticStyle: {
      "white-space": "pre-wrap"
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.adminpanel.ratingStatistics.averageRatingChange')))]), _vm._v(" "), _c('span', {
    staticClass: "info-box-number"
  }, [_vm._v(_vm._s(_vm.ratingStatistics.averageChangeOfRatingInTheLastWeek))])])])]) : _vm._e(), _vm._v(" "), (_vm.ratingStatistics) ? _c('div', {
    staticClass: "col-md-4 col-sm-6 col-xs-12 clickable",
    on: {
      "click": function($event) {
        return _vm.openModalForSelectiongClass()
      }
    }
  }, [_c('div', {
    staticClass: "info-box"
  }, [_c('span', {
    class: ['info-box-icon', _vm.selectedGroup.group && _vm.selectedGroup.group.color !== null ? _vm.selectedGroup.group.color : _vm.defaultGColor]
  }, [_c('i', {
    staticClass: "fa fa-download"
  })]), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-text",
    staticStyle: {
      "white-space": "pre-wrap"
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.adminpanel.ratingStatistics.exportUserRatingsCSV')))])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v(_vm._s(_vm.$t('pages.adminpanel.statistics.group')))])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "margin"
  }, [_c('div', {}, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label col-sm-2"
  }, [_vm._v(_vm._s(_vm.$t('pages.adminpanel.createdailychallenge.dateRange')) + ":")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('date-range-picker', {
    attrs: {
      "nameOfPicker": "customNameStatistics"
    },
    model: {
      value: (_vm.dateRange),
      callback: function($$v) {
        _vm.dateRange = $$v
      },
      expression: "dateRange"
    }
  })], 1)]), _vm._v(" "), _c('br'), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('line-chart', {
    attrs: {
      "height": 125,
      "chartData": {
        labels: _vm.timeAxis,
        datasets: [{
          label: _vm.$t('pages.adminpanel.statistics.registered'),
          backgroundColor: '#687979',
          data: _vm.registerChartY
        }]
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('line-chart', {
    attrs: {
      "height": 125,
      "chartData": {
        labels: _vm.timeAxis,
        datasets: [{
          label: _vm.$t('pages.adminpanel.statistics.active'),
          backgroundColor: '#112345',
          data: _vm.activeChartY
        }]
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('bar', {
    attrs: {
      "height": 125,
      "chartData": {
        labels: _vm.timeAxis,
        datasets: [{
          label: _vm.$t('pages.adminpanel.statistics.exC'),
          backgroundColor: '#f87979',
          data: _vm.statcorrectY
        }, {
          label: _vm.$t('pages.adminpanel.statistics.ecW'),
          backgroundColor: '#112345',
          data: _vm.statWrongY
        }]
      },
      "options": {
        scales: {
          xAxes: [{
            stacked: true,
            barPercentage: '1',
            categoryPercentage: '0.9'
          }],
          yAxes: [{
            stacked: true
          }]
        }
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  })])])])]), _vm._v(" "), (_vm.ratingStatistics) ? _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v(_vm._s(_vm.$t('pages.adminpanel.ratingStatistics.group')))])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "margin"
  }, [_c('div', {}, [_c('h5', [_vm._v(_vm._s(_vm.$t('pages.adminpanel.ratingStatistics.userRatings')))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('bar', {
    staticStyle: {
      "height": "20em"
    },
    attrs: {
      "height": 125,
      "chartData": {
        labels: _vm.ratingHistogramX,
        datasets: [{
          label: _vm.$t('pages.adminpanel.ratingStatistics.numberOfStudents'),
          backgroundColor: '#2872ca',
          data: _vm.ratingHistogramY
        }]
      },
      "options": {
        maintainAspectRatio: false,
        responsive: true,
        scales: {
          xAxes: [{
            stacked: true,
            barPercentage: '1',
            categoryPercentage: '0.9'
          }],
          yAxes: [{
            stacked: true
          }]
        }
      }
    }
  })], 1)]), _vm._v(" "), _c('h5', [_vm._v(_vm._s(_vm.$t('pages.adminpanel.ratingStatistics.exerciseRatings')))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('bar', {
    staticStyle: {
      "height": "20em"
    },
    attrs: {
      "height": 125,
      "chartData": {
        labels: _vm.ratingHistogramXExercise,
        datasets: [{
          label: _vm.$t('pages.adminpanel.ratingStatistics.numberOfExercises'),
          backgroundColor: '#2872ca',
          data: _vm.ratingHistogramYExercise
        }]
      },
      "options": {
        maintainAspectRatio: false,
        responsive: true,
        scales: {
          xAxes: [{
            stacked: true,
            barPercentage: '1.0',
            categoryPercentage: '0.9'
          }],
          yAxes: [{
            stacked: true
          }]
        }
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  })])])])]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "modal modal-default fade",
    attrs: {
      "id": "modal-selectClass"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._m(3), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.$t('pages.adminpanel.ratingStatistics.exportUserRatingsCSV')))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "col-xs-12 clickable",
    on: {
      "click": function($event) {
        return _vm.downloadUserRating(-1)
      }
    }
  }, [_c('div', {
    staticClass: "info-box"
  }, [_c('span', {
    class: ['info-box-icon', _vm.selectedGroup.group && _vm.selectedGroup.group.color !== null ? _vm.selectedGroup.group.color : _vm.defaultGColor]
  }, [_c('i', {
    staticClass: "fa fa-users"
  })]), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-text",
    staticStyle: {
      "white-space": "pre-wrap"
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.adminpanel.ratingStatistics.downloadAllUsers')))])])])]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.$t('pages.adminpanel.ratingStatistics.downloadSingleClass')))]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_c('tbody', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "3em"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('pages.adminpanel.ratingStatistics.name')))]), _vm._v(" "), _c('th')]), _vm._v(" "), _vm._l((_vm.classes), function(c, i) {
    return _c('tr', {
      staticClass: "clickable",
      on: {
        "click": function($event) {
          return _vm.downloadUserRating(c.id)
        }
      }
    }, [_c('td', [_vm._v(_vm._s(i + 1) + ".")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(c.name))]), _vm._v(" "), _vm._m(4, true)])
  })], 2)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal modal-default fade",
    attrs: {
      "id": "modal-userRatings"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._m(5), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.$t('pages.adminpanel.ratingStatistics.userRatingStatistics')))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('table', {
    staticClass: "table"
  }, [(_vm.ratingStatistics && _vm.ratingStatistics.individualUserStatistics) ? _c('tbody', [_c('tr', [_c('th', {
    staticClass: "hidden-xs",
    staticStyle: {
      "width": "3em"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('pages.adminpanel.ratingStatistics.name')))]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v(_vm._s(_vm.$t('pages.adminpanel.ratingStatistics.studentId')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('pages.adminpanel.ratingStatistics.numberOfRatingTests')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('pages.adminpanel.ratingStatistics.currentRating')))]), _vm._v(" "), _c('th')]), _vm._v(" "), _vm._l((_vm.ratingStatistics.individualUserStatistics), function(user, i) {
    return _c('tr', [_c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s(i + 1) + ".")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.name))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s(user.studentId))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.numberOfRatingTests))]), _vm._v(" "), (user.allowUseOfMyResults) ? _c('td', [_vm._v(_vm._s(user.currentRating))]) : _c('td', [_c('i', {
      staticClass: "fa fa-eye-slash"
    })]), _vm._v(" "), _c('td', [(user.allowUseOfMyResults) ? _c('a', {
      staticClass: "clickable",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          return _vm.showUserRatingStatistics(user.userId)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('pages.adminpanel.ratingStatistics.showMore')))]) : _c('span', [_vm._v(_vm._s(_vm.$t('pages.adminpanel.ratingStatistics.hiddenStatistics')))])])])
  })], 2) : _vm._e()])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-line-chart"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "info-box-icon bg-yellow"
  }, [_c('i', {
    staticClass: "fa fa-clock-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "info-box-icon bg-red"
  }, [_c('i', {
    staticClass: "fa fa-users"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('i', {
    staticClass: "fa fa-download pull-right"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2f8645dd", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2f8645dd"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/group/AdminPanel.vue
// module id = 1393
// module chunks = 1